import React, { useState } from 'react';

import { useBoardBackground } from 'app/src/components/Theme';
import { Urls } from 'app/scripts/controller/urls';
const { getBoardUrl } = Urls;
const { navigate } = require('app/scripts/controller/navigate');
import { useCurrentView } from './useCurrentView';
import styles from './ViewSwitcher.less';
import { GlyphProps, ListIcon } from '@trello/nachos/icons/list';
import { CalendarIcon } from '@trello/nachos/icons/calendar';
import { TimelineIcon } from '@trello/nachos/icons/timeline';
import { LocationIcon } from '@trello/nachos/icons/location';
import { DashboardIcon } from '@trello/nachos/icons/dashboard';
import { TableIcon } from '@trello/nachos/icons/table';

import { ViewSwitcherButtons } from './ViewSwitcherButtons';

import { ViewType } from 'app/src/components/ViewsGenerics';

export interface ViewOption {
  name: ViewType;
  icon: React.FunctionComponent<GlyphProps>;
  linkName?: string;
  navigateTo: (idBoard: string, viewName: string) => void;
}

const navigateToView = (idBoard: string, viewName: string) => {
  if (!idBoard) {
    return;
  }
  // For every first party view except calendar the viewName matches the
  const parsedViewName = viewName === 'calendar' ? 'calendar-view' : viewName;
  const url =
    parsedViewName === 'board'
      ? getBoardUrl(idBoard)
      : getBoardUrl(idBoard, parsedViewName);

  navigate(url, { trigger: true });
};

export const viewOptions: { [key in ViewType]: ViewOption } = {
  board: {
    name: ViewType.BOARD,
    icon: ListIcon,
    navigateTo: navigateToView,
  },
  table: {
    name: ViewType.TABLE,
    icon: TableIcon,
    navigateTo: navigateToView,
  },
  calendar: {
    name: ViewType.CALENDAR,
    icon: CalendarIcon,
    linkName: 'calendar-view',
    navigateTo: navigateToView,
  },
  timeline: {
    name: ViewType.TIMELINE,
    icon: TimelineIcon,
    navigateTo: navigateToView,
  },
  map: { name: ViewType.MAP, icon: LocationIcon, navigateTo: navigateToView },
  dashboard: {
    name: ViewType.DASHBOARD,
    icon: DashboardIcon,
    navigateTo: navigateToView,
  },
};

export interface ViewSwitcherProps {
  idBoard: string;
  idOrg?: string;
}

export const ViewSwitcher: React.FunctionComponent<ViewSwitcherProps> = (
  props,
) => {
  const { backgroundBrightness } = useBoardBackground();
  const [enabledViews, setEnabledViews] = useState<ViewType[]>([
    ViewType.BOARD,
    ViewType.TABLE,
    ViewType.CALENDAR,
    ViewType.TIMELINE,
    ViewType.DASHBOARD,
    ViewType.MAP,
  ]);
  const currentView = useCurrentView();

  return (
    <div className={styles.viewSwitcherContainer}>
      <ViewSwitcherButtons
        viewOptions={viewOptions}
        enabledViews={enabledViews}
        backgroundBrightness={backgroundBrightness}
        currentView={currentView}
        setEnabledViews={setEnabledViews}
        {...props}
      />
    </div>
  );
};
